import numeral from 'numeral';

numeral.register('locale', 'de', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ordinal: function (number) {
    return '.';
  },
  currency: {
    symbol: '€',
  },
});
numeral.locale('de');
numeral.options.scalePercentBy100 = false;

export default numeral;
